module.exports = "/_next/static/images/971d62c40db68238ccc107dab365c661-sanpablo-1-desktop.jpg.webp";